/**
 * Design tokens for the Sylvie & Marko wedding website.
 *
 * Centralise all colour, typography, and shadow values here so that
 * the visual identity can be updated in one place.
 */

/** Pixel font stack used throughout the site. */
export const FONT = "'Press Start 2P', monospace";

/** Colour palette — warm autumn / ryokan theme. */
export const COLOURS = {
  // Primary burnt-sienna family
  primary:       '#b85c38',   // headings, primary borders
  primaryDark:   '#8a3a20',   // shadows, pressed states
  primaryDeep:   '#5a2010',   // deepest shadow
  primaryLight:  '#c9843c',   // amber gold accents
  primaryPale:   '#f0d8b0',   // very light gold backgrounds

  // Surface / background
  cream:         '#fff8f0',   // card surfaces
  creamDark:     '#fdf5e8',   // alternating row tint
  parchment:     '#f5ede0',   // overall page background
  parchmentDark: '#f5e8d0',   // envelope screen background

  // Text
  textDark:      '#6b3820',   // body / table cell text
  textMid:       '#8a6848',   // secondary / label text
  textLight:     '#b8987a',   // muted / inactive text
  textInverted:  '#fff8e0',   // text on dark backgrounds

  // Borders
  borderGold:    '#e8c89a',   // default border
  borderAmber:   '#c9843c',   // emphasis border

  // Accent — nature / sage
  sage:          '#6b8f5e',
  sageDark:      '#4a6a3e',
  sageDeep:      '#2a4a1e',

  // Ceremony-specific accents
  torontoRed:    '#c85a28',   // Canadian / maple leaf
  canadaRed:     '#cc2222',   // flag red
  japanGold:     '#c9843c',   // ryokan warm gold

  // Environment
  skyDay:        '#87CEEB',
  skyGolden:     '#f5c890',
  waterBlue:     '#6aa8c8',
  waterShimmer:  '#9ad8f0',
  grassGreen:    '#a8c870',

  white: '#ffffff',
};

/** Box-shadow presets. */
export const SHADOW = {
  card:    '3px 3px 0 #e8c89a',
  window:  '4px 4px 0 #8a5a18',
  dialog:  '5px 5px 0 #8a5a18',
  buttonT: '3px 3px 0 #5a2010',   // Toronto (dark sienna)
  buttonJ: '3px 3px 0 #5a3808',   // Japan (dark amber)
};

/** Swipe gesture threshold in pixels for the envelope screen. */
export const SWIPE_THRESHOLD = 90;

/** Transition duration (ms) for accept/reject animations. */
export const TRANSITION_MS = 700;
